.modal {
  width: 800px;
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  justify-content: space-between;
}

.renameModal {
  width: 400px;
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  justify-content: space-between;

  input {
    margin: 10px 0;
  }
}

.header {
  display: flex;
  align-items: center;
  .select {
    width: 150px;
    margin: auto 20px;
  }
}

.table {
  height: 500px;

  a:hover {
    text-decoration: none !important;
  }
}